import * as yup from 'yup';

const validationFields = {
  email: yup
    .string()
    .email('validations.login.email.invalid')
    .required('validations.login.email.required')
    .max(50, 'validations.login.email.maxLength'),
  password: yup
    .string()
    .required('validations.login.password.required')
    .min(8, 'validations.login.password.minLength'),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = {
  email: '',
  password: '',
};



// WEBPACK FOOTER //
// ./src/forms/loginForm.js